export enum SocialLinkType {
  Facebook = 1,
  Instagram = 2,
  Twitter = 3,
  LinkedIn = 4,
  TikTok = 5,
}
